import React from 'react'
import { ListContainer, DateText, ListText, Divider, DotIcon, ListItemsWrapper, ProductAnnouncementContainer } from '../style'
import { IngressLink } from '../../style'
import { useFeatureContext } from '../../../../contexts/FeatureContext'
import { taktId } from '../../../../utils/takt'
import { WidgetTypes } from '../../../../common/constants'

export const FeatureModalList = () => {
  const { featureData, featureKeys, unreadFeatures, featureLabels, setFeatureIdEvent } = useFeatureContext()
  return (
    <ListContainer>
      <DateText fontSize="small">{featureLabels?.lastDays}</DateText>
      {featureKeys.map((key) => (
        <React.Fragment key={key}>
          <ListItemsWrapper>
            {unreadFeatures.includes(key) && <DotIcon type="circle" />}{' '}
            <ListText onClick={() => setFeatureIdEvent(key)} active={true} data-takt-id={`${taktId(WidgetTypes.WhatsNewCenterItem, key, true)}_list-button`}>
              {featureData[key].title}
            </ListText>
          </ListItemsWrapper>
          <Divider />
        </React.Fragment>
      ))}
      <ProductAnnouncementContainer>
        <IngressLink size="base" external={true} href="https://advertising.amazon.com/resources/whats-new" target="_blank" data-takt-id={taktId(WidgetTypes.WhatsNewCenterItem, 'announce-link', true)}>
          {featureLabels?.fitNoDataLinkLabel}
        </IngressLink>
      </ProductAnnouncementContainer>
    </ListContainer>
  )
}
